import {
  ORGANIZATION_ATTACH_ORG_ID,
  ORGANIZATION_UPDATE,
  ORGANIZATION_SWITCH,
  AUTH_UPDATE_USER,
} from '.';
import authenticationServiceApi from '../../api/authentication.service.api';
import organizationServiceApi from '../../api/organization.service.api';
import { setAdminMode } from './application.actions';

export const updateOrganization = () => async dispatch => {
  let { data, error } = await organizationServiceApi.me();

  if (error) {
    return false;
  }

  dispatch({
    type: ORGANIZATION_UPDATE,
    payload: data,
  });
};

export const switchOrganization =
  ({ id }) =>
  async dispatch => {
    let res = await authenticationServiceApi.switchOrganization({
      id,
    });

    if (res.error) {
      return { error: res.error };
    }

    dispatch(setAdminMode(false));

    // Update user FIRST so the ORGANIZATION_SWITCH middleware (profile-popup trigger)
    // sees fresh org-specific fields like profileCompletedAt.
    if (res.data?.user) {
      dispatch({
        type: AUTH_UPDATE_USER,
        payload: { user: res.data.user, replace: true },
      });
    }

    // `organizationId` is the switch target — the organization slice keeps the
    // previous org until ORGANIZATION_UPDATE lands, so consumers read it from here.
    dispatch({
      type: ORGANIZATION_SWITCH,
      payload: { ...res.data, organizationId: id },
    });

    return {};
  };

export const organizationAttachId = ({ id }) => ({
  type: ORGANIZATION_ATTACH_ORG_ID,
  payload: { id },
});
